import { createReducer } from 'services/reduxHelpers'
import { blacklistTypes } from 'reduxModules/actions/BlacklistActions'

/* ------------- Initial State ------------- */

export const initialState = {
  blacklistBookings: [],
  blacklistPageBookings: [],
  blacklistPassengerBookings: [],
  isLoading: false,
  isLoadingBlacklistModal: false
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [blacklistTypes.GET_BLACKLIST_BOOKINGS_ATTEMPT]: () => ({
    isLoading: true
  }),
  [blacklistTypes.GET_BLACKLIST_BOOKINGS_SUCCESS]: (_, { data: blacklistBookings }) => ({
    blacklistBookings,
    isLoading: false
  }),
  [blacklistTypes.GET_BLACKLIST_BOOKINGS_FAILURE]: () => ({
    isLoading: false
  }),

  [blacklistTypes.GET_BLACKLIST_PASSENGER_BOOKINGS_ATTEMPT]: () => ({
    isLoadingBlacklistModal: true,
  }),
  [blacklistTypes.GET_BLACKLIST_PASSENGER_BOOKINGS_SUCCESS]: (_, { data: blacklistPassengerBookings }) => ({
    blacklistPassengerBookings,
    isLoadingBlacklistModal: false
  }),
  [blacklistTypes.GET_BLACKLIST_PASSENGER_BOOKINGS_FAILURE]: () => ({
    isLoadingBlacklistModal: false
  }),

  [blacklistTypes.ADD_BLACKLIST_BOOKING_ATTEMPT]: () => ({
    isLoading: true
  }),
  [blacklistTypes.ADD_BLACKLIST_BOOKING_SUCCESS]: () => ({
    isLoading: false
  }),
  [blacklistTypes.ADD_BLACKLIST_BOOKING_FAILURE]: () => ({
    isLoading: false
  }),

  [blacklistTypes.DELETE_BLACKLIST_BOOKING_ATTEMPT]: () => ({
    isLoading: true
  }),
  [blacklistTypes.DELETE_BLACKLIST_BOOKING_SUCCESS]: () => ({
    isLoading: false
  }),
  [blacklistTypes.DELETE_BLACKLIST_BOOKING_FAILURE]: () => ({
    isLoading: false
  }),

  [blacklistTypes.DELETE_BLACKLIST_PASSENGER_ATTEMPT]: () => ({
    isLoading: true
  }),
  [blacklistTypes.DELETE_BLACKLIST_PASSENGER_SUCCESS]: () => ({
    isLoading: false
  }),
  [blacklistTypes.DELETE_BLACKLIST_PASSENGER_FAILURE]: () => ({
    isLoading: false
  })
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/BlacklistReducer.js